import React, {Component} from 'react';
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown
} from 'reactstrap';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

class HeaderDropdown extends Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
	this.logout = this.logout.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  logout(event) {
      this.props.history.push('/logout');
  }

  dropAccnt() {
	  var displayName = this.context.authUser.displayName;
	  if (displayName === '') {
		  displayName = this.context.authUser.email;
	  }
	  if (displayName === '') {
		  displayName = 'Anonymous User';
	  }
    return (
      <Dropdown nav isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle nav>
          <img src={'img/avatars/avatar.png'} className="img-avatar" alt={displayName}/>
        </DropdownToggle>
        <DropdownMenu right>
		  <DropdownItem header tag="div" className="text-center"><strong>{displayName}</strong></DropdownItem>
          <DropdownItem id="logout" onClick={this.logout}><i className="fa fa-lock"></i> Logout</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    );
  }

  render() {
    const {...attributes} = this.props;
    return (
      this.dropAccnt()
    );
  }
}

HeaderDropdown.contextTypes = {
	authUser: PropTypes.object.isRequired
}

export default withRouter(HeaderDropdown);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderDropdown.js